module.exports = __webpack_public_path__ + "img/prize-05.6d392f38.png";